//引入 ajax 请求
import axios from 'axios'
// axios.defaults.baseURL = '/api'  //关键代码

let instance = axios.create({
    // baseURL: process.env.VUE_APP_BASE_URL,  //环境（开发、正式） 文件：config >  dev.env.js、prod.env.js
    baseURL: 'http://erp.yaguanjia.com',
	// baseURL: 'http://192.168.31.193:22328',
    // baseURL: 'http://erp.test.yaguanjia.vip',
	// baseURL: 'http://192.168.0.210:8099',
})

//引入 ajax 请求
// import axios from 'axios'
// axios.defaults.baseURL = '/api'  //关键代码

// let instance = axios.create({
//     baseURL: '/api',
// })

// // http request 拦截器
// instance.interceptors.request.use(
//   config => {
//     // const token = mapState.uerInfo.token
//     // const token = JSON.parse(localStorage.getItem('uerInfo'));
//     if (JSON.parse(localStorage.getItem('uerInfo'))) { // 判断是否存在token，如果存在的话，则每个http header都加上token
//       const token = JSON.parse(localStorage.getItem('uerInfo'));
//       config.headers.token = token.token  //请求头加上token
//     }else{
//       config.headers.token = ""
//     }
//     return config
//   },
//   err => {
//     return Promise.reject(err)
//   })

// instance.interceptors.response.use(
//   response => {
//     // console.log(response)
//     // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
//     // 否则的话抛出错误
//     if (response.status === 200) {
//       return Promise.resolve(response.data);
//     } else {
//       return Promise.reject(response.data);
//     }
//   },
//   // 服务器状态码不是2开头的的情况
//   // 这里可以跟你们的后台开发人员协商好统一的错误状态码
//   // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
//   // 下面列举几个常见的操作，其他需求可自行扩展
//   error => {
//     if (error.response.status) {
//       switch (error.response.status) {
//         // 401: 未登录
//         // 未登录则跳转登录页面，并携带当前页面的路径
//         // 在登录成功后返回当前页面，这一步需要在登录页操作。
//         case 401:
//           vant.Toast.fail("身份验证失败，请关闭重新进入。");
//           break;

//         // 403 token过期
//         // 登录过期对用户进行提示
//         // 清除本地token和清空vuex中token对象
//         // 跳转登录页面
//         case 403:
//           vant.Toast.fail("登录过期，请关闭重新进入。");
//           // 清除token
//           break;

//         // 404请求不存在
//         case 404:
//           vant.Toast.fail("您访问的网页不存在。");
//           break;
//         // 其他错误，直接抛出错误提示
//         default:
//         console.log(error.response.data)
//           // vant.Toast.fail(error.response.data.message);
//       }
//       return Promise.reject(error.response);
//     }
//   }
// );



export default instance
